import { createContext, useState } from "react";
import {
  GET_BUSINESS_BY_ID_ENDPOINT,
  GET_BUSINESS_BY_PD_ACCOUNT_ID,
} from "../helpers/endpoints";

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// pdAccountId (UUID) se resuelve en pd-api; el id numérico es el legacy del monolito.
export const isValidBusinessId = (businessId) =>
  typeof businessId === "string" &&
  (UUID_REGEX.test(businessId) || !isNaN(businessId));

export const PurchaseContext = createContext();

export const PurchaseProvider = ({ children }) => {
  const [business, setBusiness] = useState(null);

  const [selectedPlan, setSelectedPlan] = useState(null);

  const [email, setEmail] = useState("");

  const fetchBusiness = (businessId) => {
    const endpoint = UUID_REGEX.test(businessId)
      ? GET_BUSINESS_BY_PD_ACCOUNT_ID
      : GET_BUSINESS_BY_ID_ENDPOINT;
    fetch(endpoint + `/${businessId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setBusiness(data);
      })
      .catch((error) => {
        console.log("Error en fetch de business: ", error);
      });
  };

  return (
    <PurchaseContext.Provider
      value={{
        business,
        setBusiness,
        selectedPlan,
        setSelectedPlan,
        email,
        setEmail,
        fetchBusiness,
      }}
    >
      {children}
    </PurchaseContext.Provider>
  );
};
